export default {"src":"/_next/static/media/expertSupport.41a55345.svg","height":24,"width":24};